
export const navigation = {
  home: "Inicio",
  services: "Servicios", 
  about: "Nosotros",
  benefits: "¿Por qué Nosotros?",
  contact: "Contacto"
};

export const hero = {
  title: "Transformamos tu",
  titleHighlight: "Visión Digital",
  titleEnd: "en Realidad",
  subtitle: "Soluciones tecnológicas integrales para impulsar tu negocio hacia el futuro digital",
  ctaPrimary: "Conoce Nuestros Servicios",
  ctaSecondary: "Solicitar Consulta Gratuita"
};

export const stats = {
  projects: "Nuevos",
  projectsLabel: "Proyectos Innovadores",
  commitment: "100%",
  commitmentLabel: "Compromiso", 
  experience: "5+",
  experienceLabel: "Años de Experiencia",
  support: "24/7",
  supportLabel: "Soporte Técnico"
};

export const services = {
  title: "Nuestros Servicios",
  subtitle: "Ofrecemos soluciones tecnológicas completas para llevar tu negocio al siguiente nivel",
  consultoria: {
    title: "Servicios de Consultoría",
    description: "Asesoramiento estratégico para optimizar tus procesos empresariales y tecnológicos.",
    features: ["Análisis de procesos", "Estrategia digital", "Optimización operativa"]
  },
  marketing: {
    title: "Marketing Digital", 
    description: "Estrategias integrales para posicionar tu marca en el mundo digital.",
    features: ["SEO/SEM", "Content Marketing", "Email Marketing"]
  },
  eventos: {
    title: "Organización de Eventos",
    description: "Planificación y ejecución de eventos corporativos memorables.",
    features: ["Eventos corporativos", "Conferencias", "Lanzamientos"]
  },
  publicidad: {
    title: "Publicidad",
    description: "Campañas publicitarias efectivas en múltiples plataformas.",
    features: ["Google Ads", "Facebook Ads", "Display Marketing"]
  },
  redes: {
    title: "Redes Sociales",
    description: "Gestión profesional de tu presencia en redes sociales.",
    features: ["Community Management", "Content Creation", "Social Analytics"]
  },
  desarrollo: {
    title: "Desarrollo Web & APIs",
    description: "Desarrollo de soluciones web modernas y APIs robustas.",
    features: ["Desarrollo Web", "APIs REST", "Integraciones"]
  },
  web3: {
    title: "Tecnologías WEB3",
    description: "Implementación de soluciones blockchain y tecnologías descentralizadas.",
    features: ["Smart Contracts", "DApps", "NFT Platforms"]
  },
  ecommerce: {
    title: "E-commerce & Tiendas Online",
    description: "Soluciones completas para tu negocio online.",
    features: ["Tiendas online", "Pasarelas de pago", "Gestión de inventario"]
  },
  viewMore: "Ver más detalles",
  hideDetails: "Ocultar detalles",
  includes: "Incluye:"
};

export const about = {
  title: "¿Quiénes somos?",
  description: "Somos GlobalTechWay, una LLC nueva y ambiciosa especializada en transformación digital. Aunque somos una empresa nueva, nuestro equipo cuenta con más de 5 años de experiencia combinada en tecnología y consultoría empresarial.",
  experiencedTeam: "Equipo Experimentado",
  experiencedTeamDesc: "Profesionales con experiencia en las mejores empresas tecnológicas",
  cuttingEdgeTech: "Tecnología de Vanguardia", 
  cuttingEdgeTechDesc: "Utilizamos las últimas tecnologías incluyendo Web3 y blockchain",
  personalizedApproach: "Enfoque Personalizado",
  personalizedApproachDesc: "Cada proyecto es único y merece una atención especializada"
};

export const benefits = {
  title: "¿Por qué elegir GlobalTechWay?",
  subtitle: "Como empresa nueva, estamos comprometidos con ofrecer la mejor calidad y atención personalizada",
  innovation: {
    title: "Innovación Constante",
    description: "Utilizamos las últimas tecnologías y metodologías para impulsar tu negocio hacia el futuro digital."
  },
  team: {
    title: "Equipo Especializado", 
    description: "Profesionales expertos en cada área tecnológica listos para transformar tus ideas en realidad."
  },
  quality: {
    title: "Calidad Garantizada",
    description: "Comprometidos con la excelencia en cada proyecto, asegurando resultados que superan expectativas."
  },
  attention: {
    title: "Atención Personalizada",
    description: "Cada cliente es único. Adaptamos nuestras soluciones a tus necesidades específicas."
  }
};

export const cta = {
  title: "¿Listo para ser nuestro próximo proyecto exitoso?",
  subtitle: "Como empresa nueva, estamos emocionados de trabajar contigo y crear algo increíble juntos",
  button: "Solicitar Consulta Gratuita"
};

export const contact = {
  title: "Contáctanos",
  subtitle: "Estamos aquí para ayudarte a alcanzar tus objetivos digitales",
  email: "Email",
  phone: "Teléfono", 
  schedule: "Horario de Atención",
  scheduleWeekdays: "Lunes - Viernes: 9:00 AM - 6:00 PM",
  scheduleWeekend: "Sábados: 10:00 AM - 2:00 PM",
  form: {
    name: "Nombre",
    nameRequired: "Nombre *",
    namePlaceholder: "Tu nombre completo",
    email: "Email",
    emailRequired: "Email *", 
    emailPlaceholder: "tu@email.com",
    company: "Empresa",
    companyPlaceholder: "Nombre de tu empresa",
    service: "Servicio de Interés",
    serviceRequired: "Servicio de Interés *",
    servicePlaceholder: "Selecciona un servicio",
    message: "Mensaje",
    messageRequired: "Mensaje *",
    messagePlaceholder: "Cuéntanos sobre tu proyecto y cómo podemos ayudarte...",
    maxChars: "Máximo 500 caracteres",
    submit: "Enviar Mensaje",
    services: {
      consultoria: "Servicios de Consultoría",
      marketing: "Marketing Digital", 
      eventos: "Organización de Eventos",
      publicidad: "Publicidad",
      redes: "Redes Sociales",
      desarrollo: "Desarrollo Web & APIs",
      web3: "Tecnologías WEB3",
      ecommerce: "E-commerce & Tiendas Online"
    }
  }
};

export const footer = {
  description: "Transformamos tu visión digital en realidad con soluciones tecnológicas innovadoras y servicios de consultoría especializados.",
  services: "Servicios",
  quickLinks: "Enlaces Rápidos",
  consulting: "Consultoría",
  digitalMarketing: "Marketing Digital", 
  webDevelopment: "Desarrollo Web",
  ecommerce: "E-commerce",
  web3: "WEB3",
  home: "Inicio",
  about: "Nosotros", 
  whyUs: "¿Por qué Nosotros?",
  contact: "Contacto",
  madeWith: "Made with Readdy",
  copyright: "© 2025 GlobalTechWay LLC. Todos los derechos reservados."
};

export const common = {
  language: "English"
};

export default {
  navigation,
  hero,
  stats,
  services,
  about,
  benefits,
  cta,
  contact,
  footer,
  common
};
